export default __webpack_public_path__ + "static/media/hero_illust@3x.2eef3c00.png";